import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { FunctionSummaryModel } from "@app/models/functioninfo/functionSummary.model";

@Injectable({ providedIn: "root" })
export class PermissionService {
  private service = "api/PermissionService";

  constructor(private http: HttpClient) {

  }

  public getUserFunctions(userId: number) {
    return this.http.get<FunctionSummaryModel[]>(`${this.service}/getUserFunctions/${userId}`);
  }
}
